const imageCache: Record<string, string> = {}
export async function getRotatedImageUrl(imageUrl: string, angle: number): Promise<string> {
  const cacheKey = `${imageUrl}-${angle}`
  if (imageCache[cacheKey]) {
    return imageCache[cacheKey]
  }

  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    const img = new Image()

    img.crossOrigin = "anonymous"

    img.onload = () => {
      canvas.width = img.width
      canvas.height = img.height

      if (!ctx) {
        reject(new Error("Could not get canvas context"))
        return
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.translate(canvas.width / 2, canvas.height / 2) // Move to center
      ctx.rotate((angle * Math.PI) / 180) // Rotate in radians
      ctx.drawImage(img, -img.width / 2, -img.height / 2) // Draw centered

      const dataUrl = canvas.toDataURL("image/png")
      imageCache[cacheKey] = dataUrl
      resolve(dataUrl)
    }

    img.onerror = () => reject(new Error("Failed to load tower image"))
    img.src = imageUrl
  })
}

